// extracted by mini-css-extract-plugin
export default {"container":"tag_container__XDKvQ","first":"tag_first__BssPv","btn":"tag_btn__l56Pp","all":"tag_all__6Np4T","client":"tag_client__g7x91"};